export default __webpack_public_path__ + "static/media/curve-bg.01a300f5.svg";